
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8493_4595)"}},[_c('path',{attrs:{"d":"M9.82 3.033l.723-.723L8.807.574l-.954.954L6.627.59 4.768 2.45l.938 1.226-.468.468L4.75 5.25 0 10l1.427 1.426L7.21 5.642l1.667 2.18L12 4.7 9.82 3.033z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8493_4595"}},[_c('path',{attrs:{"d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    